export default function isAuth(stat) {
  switch (stat) {
    case 1:
    case 2:
    case 3:
      return true;
    default:
      return false;
  }
}